export const suppliersEndpoints = {
  validateBankDetails: { method: 'post', path: '/validate-bank-details' },
  validateAba: { method: 'post', path: '/validate-aba' },
  validateBankAccount: { method: 'post', path: '/validate-bank-account' },
  listSuppliersPaginated: { method: 'post', path: '/paginated' },
  listSuppliersByCategories: { method: 'post', path: '/by-categories' },
  createSupplier: { method: 'post', path: '/create' },
  getSupplierOverview: { method: 'get', path: '/{id}/overview' },
  getSupplierOverviewFields: { method: 'get', path: '/{id}/overview/fields' },
  getSupplierOverviewFieldOptions: { method: 'get', path: '/{id}/overview/fields/{fieldId}/options' },
  createSupplierOverviewFieldOption: { method: 'post', path: '/overview/fields/{fieldId}/options' },
  setSupplierOverviewFieldValue: { method: 'post', path: '/{id}/overview/fields/{fieldId}/value' },
  getSupplierAggregationSources: { method: 'get', path: '/{id}/custom-fields/{customFieldId}/aggregation-sources' },
  getSupplierForConditions: { method: 'get', path: '/{id}/for-conditions' },
  updateSupplier: { method: 'post', path: '/{id}/update' },
  archiveSupplier: { method: 'post', path: '/{id}/archive' },
  getSupplierMergeableFields: { method: 'post', path: '/mergeable-fields' },
  mergeSuppliers: { method: 'post', path: '/merge-organisation-suppliers' },
  getSupplierOverviewConfig: { method: 'get', path: '/overview-config' },
  getSupplierProfileOverviewFieldValues: { method: 'get', path: '/{id}/profiles/fields' },
  listGlobalAndOrgSupplierBrands: { method: 'get', path: '/global-and-org-supplier-brands' },
  uploadSuppliers: { method: 'post', path: '/bulk-upload' },
  getSupplierSubmissions: { method: 'get', path: '/{id}/submissions' },
  getSupplierSubmission: { method: 'get', path: '/submission/{id}' },
  uploadHistoricSubmissions: { method: 'post', path: '/historic-submissions' },
  getGlobalSupplierMatches: { method: 'get', path: '/global-matches' },
  linkOrgSuppliersToGlobal: { method: 'post', path: '/link-org-suppliers-to-global' },
  // internal contacts
  getSupplierInternalContacts: { method: 'get', path: '/{supplierId}/internal-contacts' },
  insertSupplierInternalContact: { method: 'post', path: '/{supplierId}/internal-contacts' },
  updateSupplierInternalContact: { method: 'post', path: '/{supplierId}/internal-contacts/{contactId}/update' },
  deleteSupplierInternalContact: { method: 'post', path: '/{supplierId}/internal-contacts/{contactId}/delete' },
  // external contacts
  getSupplierExternalContacts: { method: 'get', path: '/{supplierId}/external-contacts' },
  insertSupplierExternalContact: { method: 'post', path: '/{supplierId}/external-contacts' },
  updateSupplierExternalContact: { method: 'post', path: '/{supplierId}/external-contacts/{contactId}/update' },
  deleteSupplierExternalContact: { method: 'post', path: '/{supplierId}/external-contacts/{contactId}/delete' },
  // engagements
  createEngagement: { method: 'post', path: '/engagements' },
  getEngagement: { method: 'get', path: '/engagements/{id}' },
  getEngagementsForSupplier: { method: 'get', path: '/{id}/engagements' },
  // bank accounts
  getSupplierBankAccounts: { method: 'get', path: '/{id}/bank-accounts' },
  getSupplierProfileBankAccounts: { method: 'get', path: '/{id}/supplier-profiles/{profileId}/bank-accounts' },
  // tax numbers
  getSupplierTaxNumbers: { method: 'get', path: '/{id}/tax-numbers' },
  // online resources
  listSupplierOnlineResources: { method: 'get', path: '/{id}/online-resources' },
  upsertSupplierOnlineResource: { method: 'post', path: '/{id}/online-resources' },
} as const
